import { Component, OnInit, Directive } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {MatDialog as MatDialog } from "@angular/material/dialog";
import {MatSnackBar as MatSnackBar } from "@angular/material/snack-bar";
import { AddEditComponentComponent } from "./add-edit-component/add-edit-component.component";
import { CategoryService } from "src/app/e-commerce/common/category/ecommerce-service";

import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { SharedService } from "src/app/services/shared.service";
import { ToastrService } from "ngx-toastr";

@Directive()
export class ThemeCalenderComponent implements OnInit {
  todate = new Date();
  ngOnInit() {}
}

@Component({
  selector: "app-component-page",
  templateUrl: "./component-page.component.html",
  styleUrls: ["./component-page.component.css"],
})
export class ComponentPageComponent implements OnInit {
  components: any[] = [];
  categoryToEdit: any = {};
  popup: any;
  component: any = {};
  addEditComponent: boolean;
  searchText = "";

  Categories: any[] = [];
  CategoriesList: any;
  selectedCategory: any = { components: [] };

  site: any = {};
  categoryObject: any;

  constructor(
    private authService: AuthService,
    private httpClient: HttpClient,
     private snotifyService: ToastrService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private sharedService: SharedService,
    private routing: Router,
    private categoryService:CategoryService
  ) {
    
  }

  ngOnInit() {
    let user = this.authService.getLoggedUser();
    this.site.siteId = user.siteId;
    this.GetAllComponents();
  }

  GetAllComponents(id?) {
    this.httpClient
      .get("/Components/GetAllComponents")
      .subscribe((res: any) => {
        this.Categories = res;
        this.CategoriesList = res;
        console.log(this.Categories[0].category.status, "CAT");

        this.selectedCategory = this.CategoriesList.components;

        if (res.length) {
          this.GetCategoryComponents(id ? res[id] : res[0], id || 0);
        }
      });
  }

  GetCategoryComponents(cat, index) {
    this.selectedCategory = cat || { components: [] };
    this.selectedCategory.index = index;
    console.log(this.selectedCategory, "SELECTED");
  }

  FilterComponents() {
    this.Categories = [];
    if (this.searchText != "") {
      this.CategoriesList.forEach((cat) => {
        var list = [];
        var category = cat.category;
        for (let i = 0; i < cat.components.length; i++) {
          var element = cat.components[i];
          if (
            element.name.toUpperCase().indexOf(this.searchText.toUpperCase()) >=
            0
          ) {
            list.push(element);
          }
        }
        if (list.length)
          this.Categories.push({ category: category, components: list });
      });
    } else this.Categories = this.CategoriesList;

    this.selectedCategory = this.Categories.length
      ? this.Categories[0]
      : { components: [] };
    this.selectedCategory.index = 0;
  }

  changePopupHandler(popup) {
    this.popup.hide();
    this.categoryToEdit = {};
  }

  addCategoryComponent(id?) {
    const dialogRef = this.dialog.open(AddEditComponentComponent, {
      // height:"60vh",
      width: "80vh",
      data: { CategoryId: this.selectedCategory.category.id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === "done") this.GetAllComponents(this.selectedCategory.index);
    });
  }

  EditComponent(comp) {
    const dialogRef = this.dialog.open(AddEditComponentComponent, {
      // height:"60vh",

      width: "80vh",
      data: comp,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === "done")
        this.openNotifySuccess("Component Edited successfuly");

      this.GetAllComponents(this.selectedCategory.index);
    });
  }

  deleteComponent(component) {
    this.httpClient
      .post("/Components/DeleteComponent/" + component.id, {})
      .subscribe((res: any) => {
        this.openNotifySuccess("Component deleted successfuly");
        this.GetAllComponents(this.selectedCategory.index);
      });
  }

  saveCategory(pop, form) {
    if (form.invalid) {
      Object.keys(form.controls).forEach((feild) => {
        form.controls[feild].markAsTouched(true);
      });
      return;
    }
    const data = {
      id: 0,
      thumbnailImageId: 0,
      displayOrder: 0,
      parentId: 0,
      categoryTypeId: 3,
      includeInMenu: true,
      status: 5,
      categoryDetails: [
        {
          id: 0,
          name: form.value.CatName,
          slug: form.value.CatName + "-slug",
          slugInfoId: 0,
          metaTitle: "",
          metaKeywords: "",
          metaDescription: "",
          description: "",
          categoryTemplateId: 0,
          cultureId: 0,
        },
      ],
    };
    // var data = {
    //   Name: form.value.CatName,
    //   Slug: form.value.CatName + "-slug",
    //   Status: 5,
    //   CategoryTypeId: 3,
    // };

    this.categoryService.addNewCategory(data).subscribe((res) => { 
        pop.hide();
        this.openNotifySuccess("Category Added successfuly");
        this.GetAllComponents(this.CategoriesList.length);
    })
    // this.httpClient
    //   .post("/Categories/AddCategory", data)
    //   .subscribe((res: any) => {
    //     pop.hide();
    //     this.openNotifySuccess("Category Added successfuly");
    //     this.GetAllComponents(this.CategoriesList.length);
    //   });
      
  }

  setEditCategory(Cat, pop) {
    this.categoryToEdit = JSON.parse(JSON.stringify(Cat));
    this.popup = pop;
  }

  saveEditedCategory(form) {
    if (form.invalid) {
      Object.keys(form.controls).forEach((feild) => {
        form.controls[feild].markAsTouched(true);
      });
      return;
    }
    var data = {
      Id: this.categoryToEdit.id,
      Name: form.value.CatName,
      Slug: form.value.CatName,
      CategoryTypeId: 1,
      Status: 5,
    };
    this.httpClient
      .post("/Categories/AddCategory", data)
      .subscribe((res: any) => {
        this.popup.hide();
        this.openNotifySuccess("Category Edited successfuly");
        this.GetAllComponents(this.selectedCategory.index);
        this.popup = null;
        this.categoryToEdit = {};
      });
  }

  GetPreviewComp(id) {
    this.routing.navigate(["Component-Preveiw", id]);
  }

  deleteCategory(category) {
    this.httpClient
      .get(`/Categories/ChangeCategoryStatus/${category.id}/3`)
      .subscribe((res: any) => {
        this.openNotifySuccess("Category Deleted successfuly");
        this.GetAllComponents();
      });
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
}
